// A gold-bearing rock: a dark rock shot through with bright gold nuggets and
// veins — a rare, eye-catching resource. Ported 1:1 from age-of-mcp's classic
// gold-rock.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.3, 0), color: "#5e5a52",
      position: [0, 0.21, 0], scale: [1.1, 0.95, 1] },
    // gold nuggets / veins
    { geometry: new THREE.IcosahedronGeometry(0.1, 0), color: "#f2c43c",
      position: [0.14, 0.28, 0.12] },
    { geometry: new THREE.IcosahedronGeometry(0.07, 0), color: "#ffd95a",
      position: [-0.12, 0.2, 0.14] },
    { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#e0a82e",
      position: [0.05, 0.33, -0.12] },
  ];
}

export const goldRock = defineModel({
  id: "gold-rock",
  batchId: "standard",
  name: "Gold rock",
  tags: ["scenery","gold","rock","low-poly","age-of-mcp","classic"],
  summary: "Low-poly gold rock.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.42,
  parts: () => partsFor(),
  animations: [],
});
